<template>
  <div class="home">
    <!-- 第一板块：AI 分析用户 -->
    <div class="analysis-block">
      <!-- 新增Tabs切换 -->
      <el-tabs v-model="currentTab" class="platform-tabs" @tab-click="handleTabChange">
        <el-tab-pane :disabled="!applicationMarket.dy_analysis" label="分析抖音用户" name="抖音">
          <i class="iconfont icon-douyin"></i>
        </el-tab-pane>
        <el-tab-pane :disabled="!applicationMarket.xhs_analysis" label="分析小红书用户" name="小红书">
          <i class="iconfont icon-xiaohongshu"></i>
        </el-tab-pane>
        <el-tab-pane :disabled="!applicationMarket.sph_analysis" label="分析B站用户" name="B站">
          <i class="iconfont icon-bilibili"></i>
        </el-tab-pane>
        <el-tab-pane :disabled="!applicationMarket.ks_analysis" label="分析快手用户" name="快手">
          <i class="iconfont icon-kuaishou"></i>
        </el-tab-pane>
      </el-tabs>

      <h2 class="flow-text">AI 分析{{ currentTab }}用户</h2>

      <div class="analysis-input">
        <!-- 动态placeholder -->
        <el-input v-model="userLink" :placeholder="`例如：${linkExample}`" class="link-input" size="large" />

        <!-- 模式选择保持不变 -->
        <el-select v-model="selectedMode" class="mode-select" placeholder="选择模式" size="large">
          <el-option label="极速模式" value="1" />
          <el-option label="完全模式" value="360" />
        </el-select>

        <p class="analysis-hint">
          请输入<span style="color: brown; font-weight: bold;">
            {{ currentTab }}用户主页链接，</span>
          {{ platformHint }}
        </p>
      </div>

      <div class="analysis-action">
        <el-button type="primary" :loading="isLoading" class="analysis-button"
          :disabled="!userLink || !selectedMode || !isLoggedIn" @click="startAnalysis">
          {{ isLoggedIn ? '⚡ 开始分析' : '请先登录' }}
        </el-button>
      </div>
    </div>

    <!-- 第二板块：使用说明、参与内测、积分消耗标准 -->
    <div class="info-container">
      <!-- 左侧：使用说明 + 积分消耗标准 -->
      <div class="left-block">
        <h3>使用说明</h3>
        <ol>
          <li>访问抖音用户的主页</li>
          <li>复制浏览器地址栏中的链接</li>
          <li>粘贴到上方输入框</li>
          <li style="color: brown; font-weight: bold;">
            极速模式【分析部分视频，1分钟左右】完全模式【能分析拥有1千左右视频的抖音用户，时间较长，5分钟左右】
          </li>
          <li>点击“开始分析”</li>
        </ol>

        <h3>积分消耗标准</h3>
        <ul>
          <!-- 动态展示从后端获取的配置 -->
          <li>查询成本：{{ cxNum }}点/1次</li>
          <li>分析报告：{{ fxNum }}点/1次</li>
          <li>解析视频：{{ jxNum }}点/1次</li>
          <li>获取文案：{{ yyNum }}点/1次</li>
          <li>复刻成本：{{ fkNum }}点/1次</li>
          <li>发布成本：{{ fbNum }}点/1次</li>
          <li>授权成本：{{ sqNum }}点/1次</li>
        </ul>
      </div>

      <!-- 右侧：参与内测 -->
      <div class="right-block">
        <!-- 使用后端返回的 name + qrcode_url -->
        <h3>扫码联系</h3>
        <p>
          {{ contactName || '小蚂蚁AI目前处于内测阶段，如有兴趣参与内测，请使用微信扫描以下二维码：' }}
        </p>
        <div class="qrcode-container">
          <!-- 如果 contactQrcodeUrl 为空, 可以展示一个默认二维码或者留空 -->
          <img :src="contactQrcodeUrl || defaultQrcode" alt="二维码" class="qrcode" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from "@/config.js";


export default {
  name: "HomePage",

  data() {
    return {
      currentTab: '',
      applicationMarket: {},
      previousTab: '', // 用于记录上一个有效标签
      userLink: "",      // 统一链接字段
      douyinLink: "",    // 输入框中的链接
      selectedMode: "1",  // 下拉框选择的模式：极速(10)或完全(360)
      contactName: "",   // 从后端接口中拿到的 name
      contactQrcodeUrl: "", // 从后端接口中拿到的 qrcode_url
      defaultQrcode: "", // 如需默认二维码，可自行换图
      isLoading: false,  // 控制按钮 loading 状态
      // 下面是获取到的成本配置
      cxNum: "...",
      fxNum: "...",
      jxNum: "...",
      yyNum: "...",
      fkNum: "...",
      fbNum: "...",
      sqNum: "...",
      isLoggedIn: false, // 判断用户是否登录
    };
  },

  computed: {
    // 动态计算示例链接
    linkExample() {
      return this.currentTab === '抖音'
        ? 'https://www.douyin.com/user/MS4wLjABAAA...'
        : 'https://www.xiaohongshu.com/user/profile/67a95c70000000000d00a1f4';
    },
    // 平台特定提示
    platformHint() {
      return this.currentTab === '抖音'
        ? 'AI将会自动分析该用户最受欢迎的视频内容，提供用户IP分析报告及文案的复刻服务。'
        : 'AI将会分析用户笔记特征，提供内容创作建议及爆款笔记复刻方案。';
    }
  },
  mounted() {
    this.fetchContactInfo();
    this.fetchCostConfig();
    this.checkLoginStatus(); // 检查登录状态
    this.fetchApplicationMarket(); // 新增获取授权状态

  },
  methods: {

    // 新增方法：获取插件授权状态
    fetchApplicationMarket() {
      axios.get(`${config.BASE_URL}/pc/api/get_application_market.php`, {
        params: {
          user_id: this.$store.state.userId
        }
      })
        .then(res => {
          if (res.data.success) {
            this.applicationMarket = res.data.data;
            this.setDefaultTab(); // 设置默认选中标签
          }
        })
        .catch(err => console.error('获取授权失败:', err));
    },

    // 设置默认选中的标签
    setDefaultTab() {
      const authMap = {
        '抖音': this.applicationMarket.dy_analysis,
        '小红书': this.applicationMarket.xhs_analysis,
        'B站': this.applicationMarket.sph_analysis, // 假设对应字段
        '快手': this.applicationMarket.ks_analysis
      };

      // 按优先级设置默认tab
      if (authMap['抖音']) this.currentTab = '抖音';
      else if (authMap['小红书']) this.currentTab = '小红书';
      else if (authMap['B站']) this.currentTab = 'B站';
      else if (authMap['快手']) this.currentTab = '快手';
      else this.currentTab = '抖音'; // 默认值
    },

    // 获取当前域名
    getCurrentHost() {
      return window.location.origin;
    },

    handleTabChange(tabComponent) {
      // 获取实际点击的 tab 名称 (通过 paneName)
      const clickedTabName = tabComponent.paneName;
      const authStatus = this.getAuthStatus(clickedTabName); // 使用正确的变量名


      if (!authStatus) {
        this.$message.warning('暂未授权，请联系上级授权！');
        this.$nextTick(() => {
          this.currentTab = this.previousTab;
        });
        return;
      }

      if (['B站', '快手'].includes(clickedTabName)) {
        this.$message.warning('该功能正在紧急开发中，即将上线，敬请期待！');
        this.$nextTick(() => {
          this.currentTab = this.previousTab;
        });
        return;
      }

      // 记录当前 tab 作为上一个有效状态
      this.previousTab = this.currentTab;
      this.userLink = "";  // 清空输入框
      this.currentTab = clickedTabName;

    },
    // 调用接口: get_contact_info.php
    fetchContactInfo() {
      const url = `${config.BASE_URL}/pc/api/get_contact_info.php`;
      axios.post(url, {
        agent_host: this.getCurrentHost(),
      })
        .then(res => {
          if (res.data.error) {
            console.warn("获取联系我们信息失败：", res.data.error);
          } else {
            this.contactName = res.data.name || "小蚂蚁AI";
            this.contactQrcodeUrl = res.data.qrcode_url || "";
          }
        })
        .catch(err => {
          console.error("请求get_contact_info接口错误：", err);
        });
    },

    // 新增方法：获取平台授权状态
    getAuthStatus(platform) {
      const authMap = {
        '抖音': this.applicationMarket.dy_analysis,
        '小红书': this.applicationMarket.xhs_analysis,
        'B站': this.applicationMarket.sph_analysis,
        '快手': this.applicationMarket.ks_analysis
      };
      return authMap[platform] || false;
    },


    // 获取积分消耗配置
    fetchCostConfig() {
      const url = `${config.BASE_URL}/pc/api/get_cost_config.php`; // 你定义的接口地址
      axios.get(url)
        .then(res => {
          if (res.data.success) {
            // { success: true, data: { cx_num: "10", fx_num: "15", ... } }
            const d = res.data.data;
            this.cxNum = d.cx_num || "10";
            this.fxNum = d.fx_num || "15";
            this.jxNum = d.jx_num || "8";
            this.yyNum = d.yy_num || "2";
            this.fkNum = d.fk_num || "1";
            this.fbNum = d.fb_num || "1";
            this.sqNum = d.sq_num || "1";
          } else {
            console.warn("获取成本配置失败：", res.data.error);
          }
        })
        .catch(err => {
          console.error("请求 get_cost_config.php 接口错误：", err);
        });
    },

    // 检查用户是否登录
    checkLoginStatus() {
      const userId = this.$store.state.userId;
      if (userId) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    },
    startAnalysis() {
      // 平台特定校验
      if (this.currentTab === '抖音') {
        if (!this.validateDouyinLink()) return;
      } else {
        if (!this.validateXhsLink()) return;
      }

      // 开始加载
      this.isLoading = true;
      const startTime = Date.now();

      const apiUrl = `${config.BASE_URL}/pc/api/create_fx_task.php`;

      // 提交逻辑
      axios.post(apiUrl, {
        type_name: this.currentTab,
        user_id: this.$store.state.userId,
        douyinLink: this.userLink,
        selectedMode: this.selectedMode
      })
        .then(response => {
          if (response.data.success) {
            this.$message.success({
              message: '任务创建成功，请稍后于历史记录中查询！',
              duration: 3000
            });
            // 清空输入框
            this.userLink = "";
          } else {
            this.$message.error({
              message: `任务创建失败：${response.data.error}`,
              duration: 4000
            });
          }
        })
        .catch(error => {
          console.error("请求接口错误：", error);
          this.$message.error({
            message: '请求失败，请检查网络或稍后再试',
            duration: 3000
          });
        })
        .finally(() => {
          // 保证loading至少显示1秒
          const elapsed = Date.now() - startTime;
          const remainingTime = Math.max(1000 - elapsed, 0);
          setTimeout(() => {
            this.isLoading = false;
          }, remainingTime);
        });
    },

    // 完整抖音校验
    validateDouyinLink() {
      // 基础校验
      if (!this.userLink.includes("douyin.com")) {
        this.$message.warning("不是抖音链接，请检查！");
        return false;
      }

      // 视频链接校验
      if (this.userLink.includes("douyin.com/video") ||
        this.userLink.includes("douyin.com/discover")) {
        this.$message.warning("请使用用户主页链接，而非视频链接");
        return false;
      }

      // 短链接格式校验
      const shortLinkPattern = /https:\/\/v\.douyin\.com\/\w+/;
      const longLinkPattern = /https:\/\/(www\.douyin\.com|www\.iesdouyin\.com)\/user\/\w+/;

      if (!shortLinkPattern.test(this.userLink) && !longLinkPattern.test(this.userLink)) {
        this.$message.warning("抖音链接格式错误，请检查");
        return false;
      }

      return true;
    },

    // 完整小红书校验
    validateXhsLink() {
      // 基础格式校验
      const xhsPattern = /https:\/\/www\.xiaohongshu\.com\/user\/profile\/[\da-zA-Z]{24}/i;

      if (!xhsPattern.test(this.userLink)) {
        this.$message.warning("小红书链接格式错误，请检查用户主页链接");
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 10px;
}

.el-button .custom-loading .circular {
  margin-right: 6px;
  width: 18px;
  height: 18px;
  animation: loading-rotate 2s linear infinite;
}

.el-button .custom-loading .circular .path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: var(--el-button-text-color);
  stroke-linecap: round;
}

/* 第一板块：AI 分析抖音用户 */
.analysis-block {
  width: 100%;
  max-width: 880px;
  background: linear-gradient(145deg, #f8f9fa, #ffffff);
  /* 添加微渐变背景 */
  border: 1px solid rgba(161, 0, 255, 0.1);
  /* 添加主题色边框 */
  transition: transform 0.3s ease;
  /* 添加悬浮动效 */
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 30px;
  margin-bottom: 10px;
  text-align: center;
}

.analysis-block:hover {
  transform: translateY(-2px);
  /* 悬浮上移效果 */
  box-shadow: 0 8px 20px rgba(161, 0, 255, 0.1);
  /* 强化阴影 */
}

/* 流光效果标题 */
.flow-text {
  margin-bottom: 30px;
  font-size: 26px;
  font-weight: 700;
  background: linear-gradient(90deg, #00b3ff, #a100ff, #00b3ff);
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: flow 3s linear infinite;
}

@keyframes flow {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* 输入框 + 下拉框在同一行，宽度与按钮一致 */
.analysis-input {
  margin-bottom: 20px;
  text-align: left;
  max-width: 850px;
  margin: 0 auto;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* 输入框 (el-input) */
.link-input {
  flex: 1;
  min-height: 40px;
  font-size: 18px;
  border-radius: 15px;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
}

.link-input:hover {
  border-color: #a100ff;
}

.link-input:focus {
  border-color: #a100ff;
  box-shadow: 0 0 0 2px rgba(161, 0, 255, 0.1);
}

/* 下拉框 (el-select) */
.mode-select {
  width: 150px;
  min-height: 40px;
  font-size: 18px;
  border-radius: 15px;
}

.mode-select ::v-deep .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  border-radius: 15px !important;
  font-size: 18px !important;
}

.analysis-hint {
  margin-top: 10px;
  color: #666;
  font-size: 16px;
  line-height: 1.4;
  width: 100%;
}

.analysis-action {
  margin-top: 10px;
}

.analysis-button {
  font-size: 20px;
  height: 45px;
  width: 100%;
  max-width: 850px;
  padding: 12px 30px;
  border-radius: 8px;
  color: #fff;
  border: none;
  background: linear-gradient(90deg, #00b3ff, #a100ff, #00b3ff);
  background-size: 200% 100%;
  animation: flowbtn 3s linear infinite;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.analysis-button::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg,
      transparent 25%,
      rgba(255, 255, 255, 0.1) 50%,
      transparent 75%);
  animation: shine 2s infinite;
}

@keyframes shine {
  to {
    transform: translate(50%, 50%);
  }
}

@keyframes flowbtn {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* 第二板块：使用说明/参与内测/积分消耗标准容器 */
.info-container {
  display: flex;
  width: 100%;
  max-width: 930px;
  gap: 20px;
  justify-content: center;
}

.left-block,
.right-block {
  flex: 1;
  max-width: 460px;
  position: relative;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 30px;
}

.left-block::before,
.right-block::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;

  z-index: -1;
  border-radius: 14px;
}

.left-block ol li,
.left-block ul li {
  position: relative;
  padding-left: 8px;
  margin-bottom: 12px;
}


.left-block {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.left-block h3 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 20px;
}

.left-block ol,
.left-block ul {
  margin-left: 20px;
  line-height: 1.6;
  font-size: 16px;
}

.right-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.right-block h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 20px;
}

.right-block p {
  font-size: 16px;
  line-height: 1.6;
  text-align: left;
}

/* 二维码示例 */
.qrcode-container {
  margin-top: 20px;
  text-align: center;
}

.qrcode {
  width: 140px;
  height: 140px;
  border: 1px solid #eee;
  object-fit: contain;
  border-radius: 6px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(161, 0, 255, 0.1);
  border: 2px solid rgba(161, 0, 255, 0.1);
}

.qrcode:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(161, 0, 255, 0.2);
}

.platform-tabs {
  margin-bottom: -20px;
}

.platform-tabs ::v-deep .el-tabs__item {
  font-size: 18px;
  color: #666;
  transition: all 0.3s ease;
  padding: 0 24px !important;
}

.platform-tabs ::v-deep .el-tabs__item.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.platform-tabs ::v-deep .el-tabs__item.is-disabled:hover {
  color: #666 !important;
}

.platform-tabs ::v-deep .el-tabs__item.is-active {
  color: #a100ff;
  font-weight: bold;
  transform: translateY(-2px);
  text-shadow: 0 2px 4px rgba(161, 0, 255, 0.2);
}

.platform-tabs ::v-deep .el-tabs__active-bar {
  background-color: #a100ff;
  height: 3px;

}
</style>
